const CategorySelect = ({ changeFunc, valName, filtersArr, currVal }) => {
  return (
    <div className="filter-select">
      <select value={currVal} onChange={(e) => changeFunc(e.target.value)}>
        <option value="">{valName}</option>
        {filtersArr.map((f) => (
          <option key={f.slug} value={f.slug}>
            {f.name}
          </option>
        ))}
      </select>
    </div>
  );
};

export default CategorySelect;
